export class TaskAllowedTaskType {
	public index;
	
	constructor(obj) {
		this.index = obj.index;
	}
} 
